import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import TranscriptDetails from './details'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

const AiTranscripts = (props) => {
    const today = new Date();
    const data = {
        url: '/admin/ai/transcripts',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'view',
        view: {
                label: 'View',
                url: '/admin/ai/transcripts/',
                type: 'drawer',
                component: <TranscriptDetails />,
                title: 'Call Transcripts',
            },
        userfilter:[
            {
                source: 'created_at',
                label: 'Date',
                type: 'date_range',
                default: {
                    'from': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                    'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                }
            },
            {
                source: 'call_id',
                label: 'Call ID',
                type: 'text',
                default: ''
            },
            {
                source: 'speaker',
                label: 'Speaker',
                type: 'text',
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'call_id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Call ID',
                source: 'call_id',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Total Transcripts',
                source: 'transcript_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'System Messages',
                source: 'system_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'Function Calls',
                source: 'function_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'Errors',
                source: 'error_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'Partial Messages',
                source: 'partial_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'First Transcript',
                source: 'first_transcript_at',
                type: 'datetime',
                editable: false
            },
            {
                label: 'Last Transcript',
                source: 'last_transcript_at',
                type: 'datetime',
                editable: false
            }
        ]
    }
    return (
        <Panel title="AI Transcripts">
            <>
                <Tabs tabs={aiTabs} />
                <DataResource
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}

export default AiTranscripts; 